/**
 * 权利要求分析结果
 * 客户端传入的权利要求分析结果数据
 */
export interface ClaimAnalysisResult {
    /** 涉及的权利要求（如 '1', '2-3', '5-6'） */
    claim_involved?: string;
    /** 审查员的对比分析 */
    examiner_comparison?: string;
    /** 核实结论 */
    verification_conclusion?: string;
    /** 对比文件公开/常识/未公开的内容分析 */
    disclosed_common_knowledge_not_disclosed?: string;
    /** 论证强度评估（强/中/弱） */
    argument_strength?: string;
    /** 推荐的应对行动 */
    recommended_action?: string;
    /** 策略建议 */
    strategy_recommendation?: string;
    /** 论证特征（逗号分隔） */
    argument_features?: string;
}

/**
 * Request body for generateStatementOpinion API
 * Statement export request - Requires taskId and analyzeOpinionsResult from client
 */
export interface RequestBody {
    /** OAR task ID */
    task_id: string;
    /** 权利要求分析结果列表（由客户端调用权利要求分析服务后传入） */
    analyze_opinions_result?: ClaimAnalysisResult[];
}

/**
 * Combined request parameters
 */
export interface GenerateStatementOpinionApiRequestParams {
    body: RequestBody;
}

/**
 * Response data interface
 * 陈述意见生成响应
 */
export interface GenerateStatementOpinionApiResponseData {
    /** 生成的陈述意见内容 */
    opinion_content: string;
    /** 任务ID */
    task_id?: string;
    /** 生成时间戳（毫秒） */
    generated_at?: number;
    /** 内容字符数 */
    word_count?: number;
}

/**
 * API interface for generateStatementOpinion
 */
export interface GenerateStatementOpinionApi {
    /**
   * 生成陈述意见内容
   * 调用 AI 服务生成完整的陈述意见内容，基于审查意见和权利要求分析结果
   *
   * @param params - Request parameters including body
   * @returns Promise resolving to response data
   */
    generateStatementOpinion(params: GenerateStatementOpinionApiRequestParams): Promise<GenerateStatementOpinionApiResponseData>;
}

/**
 * Symbol for dependency injection
 */
export const GenerateStatementOpinionApi = Symbol.for('GenerateStatementOpinionApi');
